export const envConfigMap = {
  stage: {
    optimizely: {
      sdkKey: '3dBzfPzaktCa2WoktYaek',
      fallBackDatafileUrl:
        'https://cdn.optimizely.com/datafiles/3dBzfPzaktCa2WoktYaek.json',
    },
  },
  demo: {
    optimizely: {
      sdkKey: 'V2W1K7Kgjq4hBF29dXVhv',
      fallBackDatafileUrl:
        'https://cdn.optimizely.com/datafiles/V2W1K7Kgjq4hBF29dXVhv.json',
    },
  },
  production: {
    optimizely: {
      sdkKey: 'RHrmtTzKJbRa8H6ZPkGCY',
      fallBackDatafileUrl:
        'https://cdn.optimizely.com/datafiles/RHrmtTzKJbRa8H6ZPkGCY.json',
    },
  },
  integration: {
    optimizely: {
      sdkKey: 'Jvi927RUyV5VbL97yrCD5',
      fallBackDatafileUrl:
        'https://cdn.optimizely.com/datafiles/Jvi927RUyV5VbL97yrCD5.json',
    },
  },
  local: {
    optimizely: {
      sdkKey: 'Jvi927RUyV5VbL97yrCD5',
      fallBackDatafileUrl:
        'https://cdn.optimizely.com/datafiles/Jvi927RUyV5VbL97yrCD5.json',
    },
  },
}
